import { CLUSTER_TAG_COLORS } from './clusterModal.models';

export const handleClusterTagColor = (clusterIndex: number) => {
  const colorPair = CLUSTER_TAG_COLORS[clusterIndex % CLUSTER_TAG_COLORS.length];
  return { ...colorPair };
};
